import some from 'lodash/some'
import uniqueBy from 'lodash/uniqBy'
import * as moment from 'moment'
import * as IsActive from '../../components/is_active'
import * as LeadPostsTypes from '../lead-posts/types'
import * as Constants from './constants'
import * as Types from './types'

export const asFormFields = (post: Types.Post): Types.FormFields => {
  return {
    description: post.description,
    hosted_image_url: post.hosted_image_url,
    id: post.id,
    image_url: post.image_url,
    link_url: post.link_url,
    site_name: post.site_name,
    title: post.title,
    url: post.url,
  }
}

export const fetchQueryParamsFromState = (state: Types.FullComponentState): Types.QueryState => {
  return {
    dateSelect: state.view.dateSelect.value,
    filter: state.view.filter.value,
    limit: Constants.SERVER_PAGE_SIZE,
    pageNumber: state.page.pageNumber,
    sortBy: state.view.sort && state.view.sort.length > 0 ? state.view.sort[0].field : 'created',
    sortDir: state.view.sort && state.view.sort.length > 0 ? state.view.sort[0].dir : Constants.SORT_BY.Desc,
  }
}

export const queryParamsToState = (params: any) => {
  const newFilter = Object.keys(params).includes('filter') ?
        {
          filter: {
            description: `Show ${params.filter} records`,
            key: 'status',
            value: params.filter,
          },
        }
        : {}

  const newdateSelect = Object.keys(params).includes('dateSelect') ?
        {
          dateSelect: {
            value: params.dateSelect,
          },
        }
        : {}

  const sort = Object.keys(params).includes('sortBy') ?
        {
          sort: [{
            dir: params.sortDir,
            field: params.sortBy,
          }],
        }
        : {}

  return {...params,
    ...newFilter,
    ...newdateSelect,
    ...sort}
}

type Posts = Types.Post[] | LeadPostsTypes.LeadPost[]

export const hasMultipleCategories = (posts: Posts): boolean => {
  return uniqueBy<any>(posts, 'category_type').length > 1
}

export const isNonEmpty = (posts: Posts, columnName: string): boolean => {
  return some<any>(posts, (post) => !!post[columnName])
}

interface SubTypes {
  [key: string]: number;
}
const SubTypes: SubTypes = {
  Content: 4,
  Lead: 1,
  Preferred: 3,
  Sponsored: 2,
  }

export const subscriptionTypeToNum = (subscriptionType: string): number => SubTypes[subscriptionType]

export const issuesList = (issues: any): IsActive.Filter[] => {
  const allIssuesData: IsActive.Filter[] = issues ? issues
          .filter((i: any) => i.content_pool_size > 0)
          .map((i: any) => {
            const d: Date = new Date(i.send_at_in_timezone)
            const dateWithoutOffset = d.setMinutes(d.getMinutes() + d.getTimezoneOffset())
            const key = 'Newsletter - ' + moment(new Date(dateWithoutOffset)).format('dddd, MMM Do H:mm').toString()
            return {
              description: key,
              key: 'mode',
              value: i.id,
              }
          }) : {}

  return [Constants.DATE_SELECT_LAST_NEWSBRIEF, Constants.ALL_ARTICLES, ...allIssuesData]
}



// WEBPACK FOOTER //
// ./src/pages/posts/utils.ts